import * as React from "react";
import { Box, FormControlLabel, Checkbox, Radio } from "@mui/material";
import { commonExpenseReport } from "state/apis";
import "./index.css";
import { Grid } from "@mui/material";
import moment from "moment";
import DefaultProperty from "components/DefaultProperty";
import { useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { formatAmount } from "utils/constants";

const CommonExpense = () => {
    const propertyName = useSelector((state) => state.global.propertyName);
    const property = useSelector((state) => state.global.defaultProperty);
    const [isLoading, setIsLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const [propertyId, setPropertyId] = React.useState(property);
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const [monthChecked, setMonthChecked] = React.useState(true);
    const [dateChecked, setDateChecked] = React.useState(false);

    const start = moment().startOf("month").format("YYYY-MM-DD");
    const end = moment().endOf("month").format("YYYY-MM-DD");
    const currentMonth = moment().format("YYYY-MM");

    const [filter, setFilter] = React.useState({
        startDate: start,
        endDate: end,
        monthValue: currentMonth,
    });

    React.useEffect(() => {
        setIsLoading(true);
        if (!property) {
            setOpenDefaultProperty(true);
        }
        fetchData(propertyId);
        setIsLoading(false);
    }, [filter.startDate, filter.endDate, monthChecked, property]);

    const fetchData = async (id) => {
        try {
            const res = await commonExpenseReport({
                startDate: filter.startDate,
                endDate: filter.endDate,
            });
            setData(res.data);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setIsLoading(false);
        }
    };

    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };
    const handleAllProperty = (e) => {
        let value = e.target.checked;
        if (value) {
            setPropertyId("");
            fetchData("");
        } else {
            fetchData(property);
            setPropertyId(property);
        }
    };

    const handleMonthChange = (event) => {
        const isChecked = event.target.checked;
        setMonthChecked(isChecked);
        if (isChecked) {
            setDateChecked(false);
        }
    };

    const handleDateChange = (event) => {
        const isChecked = event.target.checked;
        setDateChecked(isChecked);
        if (isChecked) {
            setMonthChecked(false);
        }
    };

    const handleFrom = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setFilter((prevData) => ({
            ...prevData,
            startDate: formattedDate,
        }));
    };
    const handleTo = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setFilter((prevData) => ({
            ...prevData,
            endDate: formattedDate,
        }));
    };
    const handleMonth = (date) => {
        if (!date) return;
        const selectedDate = dayjs(date);

        const startDate = selectedDate.startOf("month").format("YYYY-MM-DD");
        const endDate = selectedDate.endOf("month").format("YYYY-MM-DD");

        setFilter((prevData) => ({
            ...prevData,
            startDate: startDate,
            endDate: endDate,
            monthValue: date ? date.format("YYYY-MM") : null,
        }));
    };
    const reportRef = React.useRef();

    const handlePrint = () => {
        const input = reportRef.current;

        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const margin = 10; // Add margin (padding)

            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;

            let heightLeft = imgHeight;
            let position = margin;

            pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
            heightLeft -= pdfHeight - 2 * margin;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight + margin;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
                heightLeft -= pdfHeight - 2 * margin;
            }

            pdf.save(`common-expense.pdf`);
        });
    };

    const handleDownloadCSV = () => {
        const table = document.querySelector("table");
        let csvContent = "";

        // Loop through table rows
        for (const row of table.rows) {
            const rowData = [];
            for (const cell of row.cells) {
                const cellText = cell.textContent.trim().replace(/"/g, '""');
                rowData.push(`"${cellText}"`);
            }
            csvContent += rowData.join(",") + "\n";
        }

        // Create Blob and trigger download
        const blob = new Blob([csvContent], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `common-expense.csv`;
        link.click();
        URL.revokeObjectURL(link.href); // Cleanup
    };
    let totalAmount = 0;
    return (
        <Box m="1.5rem 2.5rem" mb={5}>
            <Box display="flex" justifyContent="flex-end" pt={0} paddingLeft={0}>
                <Grid container spacing={1} p={"5px"} alignItems="center">
                    {/* <Grid item xs={2}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={data.vacant}
                                    onChange={(e) => handleAllProperty(e)}
                                    name="vacant"
                                    color="primary"
                                />
                            }
                            label="All properties"
                        />
                    </Grid> */}
                    <Grid item>
                        <FormControlLabel
                            value="month"
                            control={
                                <Radio
                                    checked={monthChecked}
                                    onChange={handleMonthChange}
                                    color="primary"
                                />
                            }
                            label="Month"
                        />
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            value="date"
                            control={
                                <Radio
                                    checked={dateChecked}
                                    onChange={handleDateChange}
                                    color="primary"
                                />
                            }
                            label="Date Wise"
                        />
                    </Grid>
                    {dateChecked && (
                        <>
                            <Grid item xs={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="From"
                                        name="contractFrom"
                                        onChange={handleFrom}
                                        value={filter.startDate ? dayjs(filter.startDate) : null}
                                        format="DD/MM/YYYY"
                                        sx={{
                                            width: "100%",
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "primary.main",
                                                },
                                            },
                                            "& .MuiInputLabel-root": {
                                                "&.Mui-focused": {
                                                    color: "primary.main",
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="To"
                                        name="contractTo"
                                        onChange={handleTo}
                                        value={filter.endDate ? dayjs(filter.endDate) : null}
                                        format="DD/MM/YYYY"
                                        sx={{
                                            width: "100%",
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "primary.main",
                                                },
                                            },
                                            "& .MuiInputLabel-root": {
                                                "&.Mui-focused": {
                                                    color: "primary.main",
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </>
                    )}
                    {monthChecked && (
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"Month"}
                                    views={["month", "year"]}
                                    name="month"
                                    onChange={handleMonth}
                                    value={filter.monthValue ? dayjs(filter.monthValue) : null}
                                    sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "primary.main",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            "&.Mui-focused": {
                                                color: "primary.main",
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                    )}
                    <Grid item xs></Grid>
                    <Grid item xs="auto">
                        <button className="download-btn" onClick={handlePrint}>
                            Download PDF
                        </button>
                    </Grid>
                    <Grid item xs="auto">
                        <button className="download-btn" onClick={handleDownloadCSV}>
                            Download CSV
                        </button>
                    </Grid>
                </Grid>
            </Box>
            {/* </Grid> */}
            <Grid item xs></Grid>

            {!property && (
                <DefaultProperty
                    open={openDefaultProperty}
                    onClose={() => handleCloseDefaultProperty}
                />
            )}

            <div className="report-container">
                <div ref={reportRef}>
                    <table border="1" cellPadding="5" cellSpacing="0">
                        <thead>
                            {/* <tr>
                                <th colSpan={10} style={{ textAlign: "center" }}>
                                    {propertyName}
                                </th>
                            </tr> */}
                            <tr>
                                <th colSpan={10} style={{ textAlign: "center" }}>
                                    {monthChecked
                                        ? `DETAILS OF COMMON EXPENSE FOR THE MONTH OF  ${moment(
                                              filter.monthValue
                                          )
                                              .format("MMMM YYYY")
                                              .toUpperCase()}`
                                        : `DETAILS OF COMMON EXPENSE FOR THE PERIOD OF  ${filter.startDate} AND ${filter.endDate}`}
                                </th>
                            </tr>

                            <tr>
                                <th style={{ textAlign: "center" }}>SL No.</th>
                                <th style={{ textAlign: "center" }}>DATE</th>
                                <th style={{ textAlign: "center" }}>BILL #</th>
                                <th style={{ textAlign: "center" }}>DESCRIPTION</th>
                                <th style={{ textAlign: "center" }}>AMOUNT</th>
                                <th style={{ textAlign: "center" }}>REMARK</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data && data.length ? (
                                <>
                                    {data.map((val, index) => {
                                        totalAmount += val.amount;
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {val?.date
                                                        ? moment(val?.date).format("DD/MM/YYYY")
                                                        : "-"}
                                                </td>
                                                <td>{val.billNumber}</td>
                                                <td>
                                                    {val.description !== null
                                                        ? val.description
                                                        : "-"}
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.amount))}
                                                </td>

                                                <td>{val.remarks !== null ? val.remarks : "-"}</td>
                                            </tr>
                                        );
                                    })}
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: "center" }}>
                                        No data found
                                    </td>
                                </tr>
                            )}

                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Total</td>
                                <td style={{ textAlign: "right" }}>
                                    {formatAmount(Number(totalAmount))}
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan={10}></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </Box>
    );
};

export default CommonExpense;
